(function($){
	OH.settings.heightControl = (function(){
		var control = new Object();

		var adjust = function($items, length){
			var groups = new Array();
			var group;
			$.each($items, function(index){
				if(index % length == 0){
					if(!!group){
						groups.push(group);
					}
					group = new Array();
				}
				group.push($(this).css("height", ""));
			});
			if(!!group){
				groups.push(group);
			}

			var groupLength = groups.length;

			var allDone = function(){
				if(!!groupLength){
					return;
				}
				
				if(OH.requireVueLoadScroll){
					OH.setHashScroll("#" + OH.settings.vueDefine.hashPrefix);
					OH.requireVueLoadScroll = false;
				}
			};

			var setHeight = function(group){
				var task = function(){
					for(var i=0,max=0; i<group.length; i++){
						max = Math.max(max, group[i].innerHeight());
					}
					for(var i=0; i<group.length; i++){
						group[i].innerHeight(max);
					}
					groupLength--;
					allDone();
				};

				var imagesLength = 0;
				var onload = function(){
					imagesLength -= 1;
					if(imagesLength == 0){
						task();
					}
				};
				var images = new Array();

				for(var i=0; i<group.length; i++){

					//todo: to define
					group[i].find('.c-thumbnail__list li').each(function(){
						if(!$(this).text()){
							$(this).css("display", "none");
						}
					});

					group[i].find('img').each(function(){
						images.push($(this));
					});
				}
				for(var i=0; i<images.length; i++){
					var elm = images[i].get(0)
					if(!elm.complete){
						imagesLength += 1;
						elm.onload = onload;
					}
				}
				if(imagesLength == 0){
					task();
				}
			};

			for(var i=0; i<groups.length; i++){
				setHeight(groups[i]);
			}
		};

		control.refined = function($parent){
			// OH.observeFontload(OH.fontLoadCases, function(){// font評価が入るとwebfont全読み込みしてからの実行になるので外した。pxでfont-size指定しているので外しても高さが変わることはない。
				if((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 600){
					adjust($parent.find('.c-vcols__col.is-sm6'), 2);
					adjust($parent.find('.c-vcols__col.is-sm12'), 1);
					adjust($parent.find('.c-cols__col.is-sm6'), 2);
					adjust($parent.find('.oc-cols__col.is-sm6'), 2);
				}
				else{
					// adjust($parent.find('.c-vcols__col.is-3 a'), 4);
					adjust($parent.find('.c-vcols__col.is-3'), 4);
					adjust($parent.find('.c-vcols__col.is-4 '), 3);
					// adjust($parent.find('.c-cols__col.is-3 '), 4);
					adjust($parent.find('.c-vcols__col.is-6'), 2);
				}
			// }, true);
		};

		control.topics = function($parent){
			adjust($parent.find('.c-vcols__col'), ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 600) ? 2 : 4);
		};
		
		var permanentHeightFixSeq = 0;
		control.permanentHeightFix = function($parent, targetClassName, spLength, pcLength){
			OH.onResizeTasks.append("heightFix" + (permanentHeightFixSeq++), function(){
				// OH.observeFontload(OH.fontLoadCases, function(){// font評価が入るとwebfont全読み込みしてからの実行になるので外した。pxでfont-size指定しているので外しても高さが変わることはない。
					adjust($parent.find("." + targetClassName), ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 600) ? spLength : pcLength);
				}, true);
			// }, true);
		}

		return control;
	})();
})(jQuery);
